import React from 'react'
import Svg from 'assets/instagram.svg'
import ContactButton from './ContactButton'

export default () => (
  <ContactButton href="https://www.instagram.com/ya_tsaryk/" svgId={Svg.id!} tooltip="Instagram" />
)
